import { render } from "./News_page_en.vue?vue&type=template&id=b3e18392&scoped=true"
import script from "./News_page_en.vue?vue&type=script&lang=js"
export * from "./News_page_en.vue?vue&type=script&lang=js"

import "./News_page_en.vue?vue&type=style&index=0&id=b3e18392&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b3e18392"

export default script